import { Box } from "arkh";
import React, { useCallback, useRef, useState } from "react";
import { View } from "react-native";
import { AbsolutePopover } from "../components/mobile/AbsolutePopover";
import { useDeviceOrientation } from "./Utils/useDeviceOrientation";

export function PopoverButton(props: {
  children: (open: () => void) => React.ReactNode;
  popoverContent: (close: () => void) => React.ReactNode;
  popoverWidth?: number;
}) {
  const [open, setOpen] = useState(false);
  const [pos, setPos] = useState({ x: 0, y: 0, w: 10 });
  const ref = useRef<View>(null);
  useDeviceOrientation();

  const onOpen = useCallback(() => {
    ref.current?.measure((x, y, width, height, pageX, pageY) => {
      setPos({ x: pageX, y: pageY + height, w: width });
      setOpen(true);
    });
  }, []);

  const onClose = useCallback(() => {
    setOpen(false);
  }, []);

  return (
    <View ref={ref} collapsable={false}>
      <Box spaceLeft="medium" />
      {props.children(onOpen)}
      {open ? (
        <AbsolutePopover
          top={pos.y ?? 0}
          left={pos.x ?? 0}
          buttonWidth={pos.w}
          popoverWidth={props.popoverWidth}
          onClose={onClose}
        >
          {props.popoverContent(onClose)}
        </AbsolutePopover>
      ) : null}
    </View>
  );
}
